import React from "react";

const SelectInput = ({ label, value, onChange, choices, error }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <select
        name="category"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">-- Select --</option>
        {choices.map((c) => (
          <option value={c.id}>{c.name}</option>
        ))}
      </select>
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default SelectInput;
